import { apiBaseUrl } from '../../../core/globalVariables';

import React, { useEffect, useState } from 'react';

import { fmesh, fullmesh } from '../../../core/globalVariables.js';

import { TiTick } from "react-icons/ti";
import { FaPencilAlt } from "react-icons/fa";

const AlterStringMetricsInline = ({
  globalState,
  globalRefs,
  catgeoryPropertyName,
  currentEditingStringValue,
}) => {

  const toastRef = globalRefs.toastRef;

  const [updatedValue, setUpdatedValue] = useState('');
  const [selectedKey, setSelectedKey] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
  const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

  const multuGroupSelectedArray =
    globalState.multuGroupSelectedArray;

  const setIsLoadingNewGeoJSONFromAnUpdate =
    globalState.setIsLoadingNewGeoJSONFromAnUpdate;

  const setAPIReportMessage =
    globalState.setAPIReportMessage;

  const setRecentChangeList =
    globalState.setRecentChangeList;

  const landKeySelectedKey =
    globalState.landKeySelectedKey;

  const selectedYearEditing =
    globalState.selectedYearEditing;

  const setSelectedYearEditing =
    globalState.setSelectedYearEditing;

  const currentMapIdRef =
    globalRefs.currentMapIdRef;

  const srid = 4326;

  const userIsMapOwner =
    globalState.userIsMapOwner;

  useEffect(() => {
    if (landKeySelectedKey) {
      setSelectedKey(landKeySelectedKey);
    }
  }, [landKeySelectedKey]);

  useEffect(() => {

    if (!selectedYearEditing || !selectedKey) return;

    const geojson = longstandingGeoJSONRef.current;

    const value =
      currentEditingStringValue ||
      geojson.features.find(f =>
        multuGroupSelectedArray.includes(f.skylark_id)
      )?.feature_data_simple_timeseries?.[selectedKey]?.[
      selectedYearEditing
      ] || '';

    setUpdatedValue(value);

  }, [
    selectedYearEditing,
    selectedKey,
    currentEditingStringValue,
    multuGroupSelectedArray
  ]);

  // -----------------------------
  // ENTER EDIT MODE
  // -----------------------------

  const handleEdit = () => {
    setIsEditing(true);
  };

  // -----------------------------
  // CONFIRM UPDATE
  // -----------------------------

  const handleConfirm = async () => {

    if (!selectedKey || updatedValue === '') return;

    setIsLoadingNewGeoJSONFromAnUpdate(true);
    setAPIReportMessage('Autosaving...');

    try {

      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No token in local storage");
      }

      const updatedGeoJSON =
        structuredClone(longstandingGeoJSONRef.current);

      const selectedTimestampMs =
        new Date(selectedYearEditing).getTime();

      const featuresToPatch = [];

      multuGroupSelectedArray.forEach((skylarkId) => {

        const feature =
          updatedGeoJSON.features.find(
            f => f.skylark_id === skylarkId
          );

        if (!feature) return;

        const series =
          feature
            .feature_data_simple_timeseries?.[selectedKey];

        if (!series) return;

        Object.keys(series).forEach((timestamp) => {

          const tsMs =
            new Date(timestamp).getTime();

          if (tsMs >= selectedTimestampMs) {
            series[timestamp] = updatedValue;
          }

        });
        featuresToPatch.push({
          skylark_id: feature.skylark_id,
          feature_data_simple_timeseries:
            feature.feature_data_simple_timeseries
        });

      });

      if (featuresToPatch.length === 0) {

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage('No features to update');

        return;
      }

      // -----------------------------
      // DIRECT HARrier API PATCH
      // -----------------------------

      const params = new URLSearchParams({
        srid: String(srid),
      });

      const url =
        `${apiBaseUrl}/api/maps/${currentMapIdRef.current}/features?${params.toString()}`;

      const response = await fetch(url, {
        method: "PATCH",

        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },

        body: JSON.stringify(featuresToPatch),
      });

      if (!response.ok) {

        const errorText =
          await response.text();

        toastRef.current(
          "Failed to Update Feature String Value"
        );

        throw new Error(
          `PATCH failed: ${response.status} ${errorText}`
        );
      }

      toastRef.current(
        "Successfully Updated Feature String Value"
      );

      await response.json();

      // -----------------------------
      // ONLY NOW update local refs
      // -----------------------------

      longstandingGeoJSONRef.current =
        updatedGeoJSON;

      setRecentChangeList(prev => [
        ...prev,
        featuresToPatch.map(f => ({
          toc: 'Value Change',
          newFeatureChange: f
        }))
      ].slice(-20));

      setTimeout(() => {

        fmesh.children = [];

        fullmesh.remove(fmesh);

        polygonCustomLayerRef.current.createShapes(
          longstandingGeoJSONRef.current,
          selectedYearEditing
        );

        polygonCustomLayerRef.current.getRandomPolygonColor(
          landKeySelectedKey
        );

        polygonCustomLayerRef.current.removeFeatureOpacities(
          fmesh,
          multuGroupSelectedArray
        );

        setIsLoadingNewGeoJSONFromAnUpdate(false);
        setAPIReportMessage('Saved');

      }, 100);

      setIsEditing(false);

    } catch (err) {

      console.error(err);

      setIsLoadingNewGeoJSONFromAnUpdate(false);
      setAPIReportMessage('Save failed');

    }

  };

  const handleCancel = () => {

    setIsEditing(false);
    setSelectedYearEditing(null);

  };

  if (!selectedKey || !selectedYearEditing) {
    return null;
  }

  return (
    <div
      style={{
        position: 'relative',
        padding: '10px'
      }}
    >

      <p
        className="editMetricPrompt"
        onClick={userIsMapOwner ? handleEdit : undefined}
        style={{
          backgroundColor: 'rgb(222, 239, 231)',
          fontSize: '8px',
          marginBottom: '6px',
          width: '100%',
          textAlign: 'center',
          borderRadius: '5px',
          cursor: userIsMapOwner ? 'pointer' : 'default',
          pointerEvents: userIsMapOwner ? 'auto' : 'none',
          opacity: userIsMapOwner ? 1 : 0.6
        }}
      >

        Click to Edit <b>{catgeoryPropertyName}</b> at{' '}

        <b>{String(selectedYearEditing)}</b>

        <button
          className="editMetricAction"
          disabled={!userIsMapOwner}
          style={{
            fontSize: '9px',
            paddingLeft: '7px',
            paddingRight: '7px',
            paddingBottom: '6px',
            paddingTop: '6px',
            cursor: userIsMapOwner
              ? 'pointer'
              : 'not-allowed',
            marginLeft: '5px',
            top: '-5px',
            borderRadius: '20px',
            color: '#29645D',
            opacity: userIsMapOwner ? 1 : 0.5
          }}
        >
          <FaPencilAlt />
        </button>

      </p>

      {isEditing && (
        <>
          <input
            type="text"
            value={updatedValue}
            onChange={e =>
              setUpdatedValue(e.target.value)
            }
            placeholder={`Enter new ${selectedKey} value`}
            style={{
              width: '100px',
              padding: '6px',
              fontSize: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              marginBottom: '8px',
            }}
          />

          <div
            style={{
              display: 'inline-block',
              width: '150px',
              marginLeft: '0px',
              position: 'absolute',
              top: '25px'
            }}
          >
            <button
              className="altervaluesbuttonsConfirm"
              onClick={handleConfirm}
            >
              <TiTick />
            </button>
          </div>
        </>
      )}

    </div>
  );
};

export default AlterStringMetricsInline;
